/**
 * FamilySubjectPicker — „За кого": аз или дете от педиатричния модул.
 * Управлява индексите, силантите, дневника и четкането в DHI.
 */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Users } from "lucide-react";
import { useAuth } from "@/App";

export default function FamilySubjectPicker({ value, onChange, isDark = false }) {
  const { API } = useAuth();
  const [subjects, setSubjects] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/dental-prevention/indices`);
        setSubjects(data.subjects || []);
      } catch { setSubjects([]); }
    })();
  }, [API]);

  if (subjects.length <= 1) return null;
  const border = isDark ? "border-white/10" : "border-gray-200";

  return (
    <div className={`mb-4 p-3 rounded-xl border ${border} ${
      isDark ? "bg-white/[0.03]" : "bg-white"}`} data-testid="dhi-family-picker">
      <div className="text-[10px] uppercase tracking-wider font-bold opacity-50 mb-1.5 inline-flex items-center gap-1">
        <Users className="w-3 h-3" /> За кого са индексите, силантите, дневникът и четкането
      </div>
      <div className="flex flex-wrap gap-1.5">
        {subjects.map((s) => {
          const on = (value || null) === (s.child_id || null);
          return (
            <button key={s.child_id || "self"}
              onClick={() => onChange(s.child_id || null)}
              className={`px-2.5 py-1 rounded-full text-[11px] font-bold border transition ${
                on ? "border-cyan-500 bg-cyan-500/15 text-cyan-500" : `${border} opacity-70`}`}
              data-testid={`dhi-subject-${s.child_id || "self"}`}>
              {s.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}
